module.exports = __webpack_public_path__ + "static/media/logoCentermaqBranco.6597dc90.png";